import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { HttpUtilService } from 'src/app/services/common/http-util.service';
import { ResponseResult } from '../models/response-result.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServerMaintenanceSchedule } from '../models/server-maintenance-schedule.model';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  constructor(private http: HttpUtilService) {}

  getUserMenu(): Observable<ResponseResult<MenuItem[]>> {
    // return this.http.get<ResponseResult<MenuItem[]>>(
    //   environment.apiUrl.authorizationService +
    //     'authorization/getMenuJsonByRole'
    // );
    return of({
      isSuccess: true,
      status: 200,
      data: [
        {
          id: '100',
          label: 'Home',
          icon: 'pi pi-home',
          routerLink: '/home',
          visible: true,
          // routerLinkActiveOptions: { exact: true },
        },
        // {
        //   label: 'File',
        //   icon: 'pi pi-fw pi-file',
        //   items: [
        //     {
        //       label: 'New',
        //       icon: 'pi pi-fw pi-plus',
        //       items: [
        //         {
        //           label: 'Bookmark',
        //           icon: 'pi pi-fw pi-bookmark',
        //         },
        //         {
        //           label: 'Video',
        //           icon: 'pi pi-fw pi-video',
        //           items: [
        //             {
        //               label: 'Home 2',
        //               icon: 'pi pi-home',
        //               routerLink: '/home2',
        //             },
        //             {
        //               label: 'Home 3',
        //               icon: 'pi pi-home',
        //               // url: '{baseUrl}/home3',
        //               routerLink: '/home3',
        //               target: '_blank',
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     {
        //       label: 'Delete',
        //       icon: 'pi pi-fw pi-trash',
        //     },
        //     {
        //       label: 'Export',
        //       icon: 'pi pi-fw pi-external-link',
        //     },
        //   ],
        // },
        {
          id: '200',
          label: 'Export Document',
          // icon: 'pi pi-pw pi-file-export',
          icon: 'fa-solid fa-file',
          expanded: true,
          visible: true,
          items: [
            {
              id: '210',
              label: 'Search Invoice',
              icon: 'pi pi-fw pi-search',
              routerLink: '/export-document/search-for-printing',
              visible: true,
            },
            {
              id: '220',
              label: 'Search Invoice',
              icon: 'pi pi-fw pi-search',
              routerLink:
                '/export-document/search-for-printing-restore-criteria',
              visible: false,
            },
            {
              id: '230',
              label: 'Search Invoice',
              icon: 'pi pi-fw pi-search',
              routerLink: '/export-document/so-detail',
              visible: false,
            },
            {
              id: '280',
              label: 'Create Revise Request',
              icon: 'fa-solid fa-file-circle-plus',
              routerLink: '/export-document/create-revise-request',
              visible: false,
            },
            {
              id: '281',
              label: 'Create Revise Request',
              icon: 'fa-solid fa-file-circle-plus',
              routerLink: '/export-document/edit-revise-request',
              visible: false,
            },
            {
              id: '292',
              label: 'Create Revise Request',
              icon: 'fa-solid fa-file-circle-plus',
              routerLink: '/export-document/view-revise-request',
              visible: false,
            },
            {
              id: '291',
              label: 'Create Revise Request',
              icon: 'fa-solid fa-file-circle-plus',
              routerLink: '/export-document/approve-revise-request',
              visible: false,
            },
            // {
            //   id: '6',
            //   label: 'Create Revise Request',
            //   icon: 'fa-solid fa-file-circle-plus',
            //   routerLink: '/export-document/complete-revise-request',
            //   visible: false,
            // },
          ],
        },
        // {
        //   label: 'Example',
        //   icon: 'pi pi-pw pi-info-circle',
        //   items: [
        //     {
        //       label: 'Search',
        //       icon: 'pi pi-fw pi-search',
        //       routerLink: '/example/search',
        //     },
        //     {
        //       label: 'Manage',
        //       icon: 'pi pi-fw pi-file-edit',
        //       routerLink: '/example/manage',
        //     },
        //   ],
        // },
        {
          id: '300',
          label: 'Master Management',
          icon: 'fa-solid fa-gears',
          visible: true,
          expanded: true,
          items: [
            {
              id: '310',
              label: 'Document Required Master',
              icon: 'bi bi-file-earmark-text',
              routerLink: '/master/document-required-master',
              visible: true,
            },
            {
              id: '320',
              label: 'Document Required Master',
              icon: 'bi bi-file-earmark-text',
              routerLink: '/master/document-required-master-restore-criteria',
              visible: false,
            },
            {
              id: '311',
              label: 'Add Customer Account',
              icon: 'bi bi-file-earmark-plus',
              routerLink: '/master/create-document-required-master',
              visible: false,
            },
            {
              id: '312',
              label: 'Edit Customer Details',
              icon: 'pi pi-file-edit',
              routerLink: '/master/edit-document-required-master',
              visible: false,
            },
            {
              id: '330',
              label: 'Public Document Owner',
              icon: 'fi fi-rr-megaphone',
              routerLink: '/master/public-document-owner',
              visible: true,
            },
            {
              id: '340',
              label: 'User Management',
              icon: 'fa-regular fa-user',
              routerLink: '/master/user-management',
              visible: true,
            },
            {
              id: '341',
              label: 'Add User Account',
              icon: 'fa-solid fa-user-plus',
              routerLink: '/master/create-user-management',
              visible: false,
            },
            {
              id: '342',
              label: 'Edit User Details',
              icon: 'fa-solid fa-user-pen',
              routerLink: '/master/edit-user-management',
              visible: false,
            },
            {
              id: '350',
              label: 'KPI Management',
              icon: 'fi fi-rs-speedometer-kpi',
              routerLink: '/master/kpi-management',
              visible: true,
            },
            {
              id: '351',
              label: 'Add KPI Details',
              icon: 'fi fi-rs-speedometer-kpi',
              routerLink: '/master/create-kpi-management',
              visible: false,
            },
            {
              id: '352',
              label: 'Edit KPI Details',
              icon: 'fi fi-rs-speedometer-kpi',
              routerLink: '/master/edit-kpi-management',
              visible: false,
            },
          ],
        },
      ],
    });
  }

  postCheckMaintenance(): Observable<
    ResponseResult<ServerMaintenanceSchedule[]>
  > {
    // return this.http.post<ResponseResult<ServerMaintenanceSchedule[]>>(
    //   environment.apiUrl.authorizationService +
    //     'authorization/getMaintenanceInfo',
    //   null
    // );
    return of({
      isSuccess: false,
      status: 200,
      data: [
        {
          start: '03/08/2022 12:00',
          end: '03/08/2022 12:00',
          system: 'Test',
          effective: true,
          blockAccess: true,
          blockMenu: true,
        },
      ],
    });
  }

  postCheckAllowAccess(): Observable<ResponseResult<boolean>> {
    // return this.http.post<ResponseResult<boolean>>(
    //   environment.apiUrl.authorizationService + 'authorization/getWhiteList',
    //   null
    // );
    return of({
      isSuccess: true,
      status: 200,
      data: true,
    });
  }
}
